import angular from 'angular';
import ColorSelectorCtrl from './colorSelector.controller';
import colorSelectorDirective from './colorSelector.directive';

import predefinedColorDirective from './components/predefinedColor';

export default angular.module('colorSelector', [
        predefinedColorDirective,
    ])
    .directive('colorSelector', colorSelectorDirective)
    .controller('ColorSelectorCtrl', ColorSelectorCtrl)
    .name;